import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import axios, { AxiosError } from 'axios'

interface ExperienceInitialStateType {
  data: {
    experience: any,
    legend: any,
    axis: any
  }
  loading: boolean
  status: number | null
  errorStatus: number | null
}

const initialState: ExperienceInitialStateType = {
  data: {
    experience: [],
    legend: [],
    axis: {}
  },
  loading: false,
  status: null,
  errorStatus: null
}

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const getExperience = createAsyncThunk('ExperienceSlice/getExperience', async (_, thunkApi) => {
  try {
    const experienceResponse = await axios.get(apiUrl + '/experience')
    const experienceData = await experienceResponse.data.data
    return thunkApi.fulfillWithValue(experienceData)
  } catch (error) {
    const err = error as AxiosError
    return thunkApi.rejectWithValue(err.response?.status)
  }
})

const ExperienceSlice = createSlice({
  name: "ExperienceSlice",
  initialState,
  reducers: {
    getValue: (state, action) => {
      state.data = action.payload
    },
    resetValue: (state) => {
      state.data = { experience: [], legend: [], axis: {} }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getExperience.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getExperience.fulfilled, (state, action) => {
      state.data = action.payload
    })
    builder.addCase(getExperience.rejected, (state, action) => {
      state.errorStatus = action.payload as number
    })
    builder.addMatcher(isAnyOf(
      getExperience.fulfilled, getExperience.rejected), (state) => {
        state.loading = false
      })
  }
})

const ExperienceThunks = {
  getExperience,
}

export const ExperienceServices = {
  ...ExperienceThunks,
  actions: ExperienceSlice.actions,
}

const ExperienceReducer = ExperienceSlice.reducer
export default ExperienceReducer